var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3333 43.6667C93.3333 66.6792 74.6792 85.3333 51.6667 85.3333C28.6542 85.3333 10 66.6792 10 43.6667C10 20.6542 28.6542 2 51.6667 2C74.6792 2 93.3333 20.6542 93.3333 43.6667ZM51.6667 22.8333C50.2292 22.8333 49.0625 24 49.0625 25.4375V41.0625H33.4375C32.7468 41.0625 32.0845 41.3369 31.5961 41.8252C31.1077 42.3136 30.8333 42.976 30.8333 43.6667C30.8333 44.3573 31.1077 45.0197 31.5961 45.5081C32.0845 45.9965 32.7468 46.2708 33.4375 46.2708H49.0625V61.8958C49.0625 62.5865 49.3369 63.2489 49.8252 63.7373C50.3136 64.2256 50.976 64.5 51.6667 64.5C52.3573 64.5 53.0197 64.2256 53.5081 63.7373C53.9965 63.2489 54.2708 62.5865 54.2708 61.8958V46.2708H69.8958C70.5865 46.2708 71.2489 45.9965 71.7373 45.5081C72.2256 45.0197 72.5 44.3573 72.5 43.6667C72.5 42.976 72.2256 42.3136 71.7373 41.8252C71.2489 41.3369 70.5865 41.0625 69.8958 41.0625H54.2708V25.4375C54.2708 24 53.1042 22.8333 51.6667 22.8333Z",
    fill: "#111D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddicon);
export default __webpack_public_path__ + "static/media/addicon.0e60cabe1e3afde5449d68ff14af9ebb.svg";
export { ForwardRef as ReactComponent };